define('sentient/aba/models/ExerciseModelProxy',[
	'lodash',
	'backbone',
	'loglevel'
	], function(_, Backbone, log) {
		var ExerciseModelProxy = Backbone.Model.extend({
			defaults: {
				pauseCounter: 0
			},
			initialize: function(argument) {
				//log.debug('creating new ExerciseModelProxy', this);
				//log.debug('createPracticeScript', this.createPracticeScript(3, 'foobar'));
			},
			createPracticeScript: function(practiceTaskCount, stepUID) {
				var practiceScript = [];
				var taskCount = 0;
				var primeCount = 0;
				var tasks = [];
				var primes = [];
				var countdown = {
					'type': 'exerciseCountDown',
					'options': {
						'dialog': 'Ready!',
						'countdownStart': 3,
						'countdownTime': 3000,
						'stepUID': 'post-pause'
					}
				};
				var returnToScript = {
					'type': 'returnToScript',
					'options': {
						'stepUID': 'post-pause'
					}
				};
				if (this.get('countdown')) {countdown = this.get('countdown');}
				if (this.get('primes')) {primes = this.get('primes'); primeCount = primes.length;}
				if (this.get('tasks')) {tasks = this.get('tasks'); taskCount = tasks.length;}
				practiceScript.push(countdown);
				for (var i = 0; i < practiceTaskCount; i++) {
					var prime = null;
					if (primes.length > 0) {
						var randomPrimeIndex = Math.floor((Math.random() * (primeCount - 1)));
						prime = _.cloneDeep(primes[randomPrimeIndex]);
						prime['options']['stepUID'] = stepUID + '-' + this.get('pauseCounter') + '-post-pause';
						this.set('pauseCounter', this.get('pauseCounter') + 1);
						practiceScript.push(prime);
					}
					var randomTaskIndex = Math.floor((Math.random() * (taskCount - 1)));
					var task = _.cloneDeep(tasks[randomTaskIndex]);
					task['options']['stepUID'] = stepUID + '-' + this.get('pauseCounter') + '-post-pause';
					this.set('pauseCounter', this.get('pauseCounter') + 1);
					if (prime) {
						task['options']['primeIndex'] = prime['options']['index'];
						task['options']['primeName'] = prime['options']['name'];
						task['options']['primeTime'] = prime['options']['primingTime'];
					}
					practiceScript.push(task);
					//log.debug("prime",prime);
					//log.debug("task",task);
				}
				returnToScript['options']['stepUID'] = stepUID + '-' + this.get('pauseCounter') + '-post-pause';
				this.set('pauseCounter', this.get('pauseCounter') + 1);
				practiceScript.push(returnToScript);
				return practiceScript;
			}
		});
return ExerciseModelProxy;
});

